/**
 * Componente que escucha eventos de expiración de token
 * y redirige al login automáticamente
 */
import { useEffect, useRef } from "react";
import { useAuth } from "react-oidc-context";
import { AUTH_EXPIRED_EVENT } from "@/lib/api-client";

export function AuthExpirationHandler() {
  const auth = useAuth();
  const isHandlingRef = useRef(false);

  useEffect(() => {
    const handleAuthExpired = async () => {
      // Evitar múltiples redirecciones simultáneas
      if (isHandlingRef.current) return;
      isHandlingRef.current = true;

      console.warn("[AuthExpirationHandler] Token expirado detectado. Intentando renovar...");

      try {
        // Intentar renovar el token silenciosamente
        await auth.signinSilent();
        console.log("[AuthExpirationHandler] Token renovado exitosamente.");
        isHandlingRef.current = false;
      } catch (error) {
        console.warn("[AuthExpirationHandler] No se pudo renovar el token. Redirigiendo al login...");
        // Si falla el silent renew, redirigir al login
        const returnUrl = window.location.pathname + window.location.search;
        auth.signinRedirect({
          state: { returnUrl },
        });
      }
    };

    // Escuchar el evento de token expirado
    window.addEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired);

    return () => {
      window.removeEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired);
    };
  }, [auth]);

  // Este componente no renderiza nada
  return null;
}
